// extracted by mini-css-extract-plugin
module.exports = {"image-attachment__inner":"image-attachment__inner__3qFwJ"};